import React, { Fragment } from 'react'
import { Label } from '../../../components'
import { getKeyOfOpt, isMatch, lookupOption, arrayContainsKey, renderOptionList } from './optionUtils'

const CheckList = ({
  id,
  name,
  label,
  helpText,
  value,
  context,
  rtOptions,
  onChange,
  optionKeyName,
  getOptionTextFn,
}) => {

  /*
    Translate val (the current value of the selection variable, as far as the UI control/component is concerned)
    into the actual value to be saved in the data context.
  */
  const localMultiChange = (target) => {
    let {
      value: optionKeyVal,
      checked,
    } = target
    const alreadySelected = arrayContainsKey(value, optionKeyVal)
    if (typeof checked === 'undefined') checked = true
    if (checked && !alreadySelected) { // add checked option to selection
      const selection = [...value, lookupOption(optionKeyVal, rtOptions)]
      return selection
    } // else
    if (!checked && alreadySelected) { // removed unchecked option from selection
      const newArray = value.filter(selectedOption => !isMatch(selectedOption, optionKeyVal))
      const selection = newArray.length ? newArray : null
      return selection
    } // else no change
    return value
  }
  
  return (
    <Fragment>
      <Label name={name} label={label} helpText={helpText} forId={null}/>
      {renderOptionList(rtOptions, false, context, (opt, scope) => {
        const optKey = getKeyOfOpt(opt, optionKeyName)
        const optId = id + '|' + optKey
        return (
          <div key={optKey} className="form-check mt-1">
            <input type="checkbox" id={optId} name={id}
                   className="form-check-input"
                   value={optKey}
                   checked={arrayContainsKey(value, optKey)}
                   onChange={e => onChange(localMultiChange(e.target))}/>
            <Label name={id}
                   label={getOptionTextFn(opt, scope)}
                   forId={optId}
                   className={'form-check-label'}/>
          </div>
        )
      })}
    </Fragment>
  )
}

export default CheckList
